// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JuegosLogos_container__-eFnt {
  animation: JuegosLogos_init__UXYm9 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_header__1ag5G {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.JuegosLogos_container__-eFnt .JuegosLogos_header__1ag5G .JuegosLogos_titleContainer__2EfO3 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.JuegosLogos_container__-eFnt .JuegosLogos_header__1ag5G .JuegosLogos_titleContainer__2EfO3 h4 {
  font-size: 2rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_header__1ag5G .JuegosLogos_titleContainer__2EfO3 .JuegosLogos_add_btn__JN0OW {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 100px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_header__1ag5G .JuegosLogos_titleContainer__2EfO3 .JuegosLogos_add_btn__JN0OW:hover {
  transition: 0.3s;
  scale: 1.03;
  filter: brightness(1.2);
  cursor: pointer;
  border-radius: 5px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O {
  animation: JuegosLogos_init__UXYm9 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 50px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  width: 270px;
  height: 325px;
  border-radius: 10px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  margin-inline: 20px;
  margin-top: 50px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_gameBackground__1XX6E {
  position: absolute;
  width: 100%;
  top: 0;
  border-radius: 10px;
  object-fit: contain;
  mask-image: linear-gradient(
    180deg,
    rgb(0, 0, 0),
    rgb(0, 0, 0),
    rgb(0, 0, 0),
    rgba(0, 0, 0, 0)
  );
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_data__LtYPw {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  transition: 0.3s;
  opacity: 1;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.268);
  z-index: 5;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_disabledGame__Qvn3C .JuegosLogos_gameBackground__1XX6E {
  filter: grayscale(1);
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN:hover {
  transition: 0.3s;
  scale: 1.05;
  cursor: pointer;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_data__LtYPw h4 {
  font-size: 1.5rem;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_data__LtYPw > p {
  font-size: 1.3rem;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  margin: 0;
  margin-bottom: 20px;
  margin-left: 10px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_data__LtYPw .JuegosLogos_options__g12Tz {
  transition: 0.3s;
  display: flex;
  width: 100%;
  opacity: 0;
  height: 0;
  justify-content: space-between;
  align-items: center;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_disabledGame__Qvn3C .JuegosLogos_data__LtYPw .JuegosLogos_options__g12Tz {
  transition: 0.3s;
  display: flex;
  width: 100%;
  opacity: 1;
  height: 50px;
  justify-content: space-between;
  align-items: center;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_data__LtYPw .JuegosLogos_options__g12Tz .JuegosLogos_icon__GaPfv {
  transition: 0.3s;
  font-size: 32px;
  margin-right: 10px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_data__LtYPw .JuegosLogos_options__g12Tz .JuegosLogos_icon__GaPfv:hover {
  transition: 0.3s;
  scale: 1.1;
  filter: saturate(1.4);
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN .JuegosLogos_data__LtYPw .JuegosLogos_options__g12Tz > p {
  font-size: 16px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  margin: 0;
  margin-left: 10px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_gamesContainer__cvJ\\+O .JuegosLogos_itemGame__C-KpN:hover .JuegosLogos_data__LtYPw .JuegosLogos_options__g12Tz {
  transition: 0.3s;
  opacity: 1;
  height: 50px;
}

/*---Información---*/
.JuegosLogos_container__-eFnt .JuegosLogos_dataContainer__1qhCJ .JuegosLogos_tableContainer__QKP0j {
  animation: JuegosLogos_init__UXYm9 1s;
  margin-top: 50px;
  margin-bottom: 50px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_dataContainer__1qhCJ .JuegosLogos_tableContainer__QKP0j {
  height: 500px;
  overflow-y: scroll;
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.JuegosLogos_container__-eFnt .JuegosLogos_dataContainer__1qhCJ .JuegosLogos_tableContainer__QKP0j .JuegosLogos_iconbtn__Bq3go {
  transition: 0.3s;
  font-size: 30px;
}

.JuegosLogos_container__-eFnt .JuegosLogos_dataContainer__1qhCJ .JuegosLogos_tableContainer__QKP0j .JuegosLogos_iconbtn__Bq3go:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

@keyframes JuegosLogos_init__UXYm9 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/JuegosLogos/index.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,mBAAmB;EACnB,mBAAmB;EACnB;;;;;;GAMC;AACH;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,UAAU;EACV,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,qCAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 2rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 45px;\n  width: 100px;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn:hover {\n  transition: 0.3s;\n  scale: 1.03;\n  filter: brightness(1.2);\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.container .gamesContainer {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 50px;\n}\n\n.container .gamesContainer .itemGame {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  position: relative;\n  width: 270px;\n  height: 325px;\n  border-radius: 10px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  margin-inline: 20px;\n  margin-top: 50px;\n}\n\n.container .gamesContainer .itemGame .gameBackground {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  border-radius: 10px;\n  object-fit: contain;\n  mask-image: linear-gradient(\n    180deg,\n    rgb(0, 0, 0),\n    rgb(0, 0, 0),\n    rgb(0, 0, 0),\n    rgba(0, 0, 0, 0)\n  );\n}\n\n.container .gamesContainer .itemGame .data {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  transition: 0.3s;\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.268);\n  z-index: 5;\n}\n\n.container .gamesContainer .disabledGame .gameBackground {\n  filter: grayscale(1);\n}\n\n.container .gamesContainer .itemGame:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.container .gamesContainer .itemGame .data h4 {\n  font-size: 1.5rem;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n  margin: 0;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n}\n\n.container .gamesContainer .itemGame .data > p {\n  font-size: 1.3rem;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n  margin: 0;\n  margin-bottom: 20px;\n  margin-left: 10px;\n}\n\n.container .gamesContainer .itemGame .data .options {\n  transition: 0.3s;\n  display: flex;\n  width: 100%;\n  opacity: 0;\n  height: 0;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .gamesContainer .disabledGame .data .options {\n  transition: 0.3s;\n  display: flex;\n  width: 100%;\n  opacity: 1;\n  height: 50px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .gamesContainer .itemGame .data .options .icon {\n  transition: 0.3s;\n  font-size: 32px;\n  margin-right: 10px;\n}\n\n.container .gamesContainer .itemGame .data .options .icon:hover {\n  transition: 0.3s;\n  scale: 1.1;\n  filter: saturate(1.4);\n}\n\n.container .gamesContainer .itemGame .data .options > p {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n  margin: 0;\n  margin-left: 10px;\n}\n\n.container .gamesContainer .itemGame:hover .data .options {\n  transition: 0.3s;\n  opacity: 1;\n  height: 50px;\n}\n\n/*---Información---*/\n.container .dataContainer .tableContainer {\n  animation: init 1s;\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n\n.container .dataContainer .tableContainer {\n  height: 500px;\n  overflow-y: scroll;\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 30px;\n}\n\n.container .dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JuegosLogos_container__-eFnt`,
	"init": `JuegosLogos_init__UXYm9`,
	"header": `JuegosLogos_header__1ag5G`,
	"titleContainer": `JuegosLogos_titleContainer__2EfO3`,
	"add_btn": `JuegosLogos_add_btn__JN0OW`,
	"gamesContainer": `JuegosLogos_gamesContainer__cvJ+O`,
	"itemGame": `JuegosLogos_itemGame__C-KpN`,
	"gameBackground": `JuegosLogos_gameBackground__1XX6E`,
	"data": `JuegosLogos_data__LtYPw`,
	"disabledGame": `JuegosLogos_disabledGame__Qvn3C`,
	"options": `JuegosLogos_options__g12Tz`,
	"icon": `JuegosLogos_icon__GaPfv`,
	"dataContainer": `JuegosLogos_dataContainer__1qhCJ`,
	"tableContainer": `JuegosLogos_tableContainer__QKP0j`,
	"iconbtn": `JuegosLogos_iconbtn__Bq3go`
};
export default ___CSS_LOADER_EXPORT___;
